import { useCallback, useEffect, useMemo, useState, type ReactNode } from "react";
import { CommandPaletteContext } from "@/providers/command-palette-context";

/**
 * Provides global open/close state for the Cmd+K palette + binds the
 * keyboard shortcut once at the document level.
 */
export function CommandPaletteProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => setOpen((prev) => !prev), []);

  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      const k = event.key.toLowerCase() === "k";
      if (k && (event.metaKey || event.ctrlKey)) {
        event.preventDefault();
        setOpen((prev) => !prev);
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  const value = useMemo(() => ({ open, setOpen, toggle }), [open, toggle]);

  return (
    <CommandPaletteContext.Provider value={value}>{children}</CommandPaletteContext.Provider>
  );
}
